import { getI18n } from 'react-i18next';

export const VALIDATION_AUCTION_TEMPLATE_EMPTY_NAME = 'validation.auctionTemplate.emptyName';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_NAME_LENGTH = 'validation.auctionTemplate.invalidNameLength';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_QUANTITY = 'validation.auctionTemplate.invalidQuantity';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_POWER = 'validation.auctionTemplate.notNullPower';
export const VALIDATION_AUCTION_TEMPLATE_DELIVERY_IN_PAST = 'validation.auctionTemplate.deliveryYearInPast';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_DELIVERY_YEAR = 'validation.auctionTemplate.notNullDeliveryYear';
export const VALIDATION_AUCTION_TEMPLATE_PRODUCT_NOT_ACTIVE = 'validation.auctionTemplate.productNotActive';
export const VALIDATION_AUCTION_TEMPLATE_PRODUCT_NOT_FOUND = 'validation.auctionTemplate.productNotExist';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SHOW_LAST_PRICE = 'validation.auctionTemplate.notNullShowLastPrice';
export const VALIDATION_AUCTION_TEMPLATE_EMPTY_SHOW_LAST_PRICE = 'validation.auctionTemplate.emptyShowLastPrice';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SHOW_RANKING = 'validation.auctionTemplate.notNullShowRanking';
export const VALIDATION_AUCTION_TEMPLATE_EMPTY_SHOW_RANKING = 'validation.auctionTemplate.emptyShowRanking';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_LIMIT_BID_MODIFICATION = 'validation.auctionTemplate.notNullLimitBidModification';
export const VALIDATION_AUCTION_TEMPLATE_EMPTY_LIMIT_BID_MODIFICATION = 'validation.auctionTemplate.emptyLimitBidModification';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_DESCRIPTION_LENGTH = 'validation.auctionTemplate.invalidDescriptionLength';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_SPOT_REFERENCE_PRICE = 'validation.auctionTemplate.invalidSpotReferencePrice';
export const VALIDATION_AUCTION_TEMPLATE_RELATIVE_DEVIATION_TOO_LOW = 'validation.auctionTemplate.relativeDeviationTooLow';
export const VALIDATION_AUCTION_TEMPLATE_RELATIVE_DEVIATION_TOO_HIGH = 'validation.auctionTemplate.relativeDeviationTooHigh';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_ABSOLUTE_DEVIATION = 'validation.auctionTemplate.invalidAbsoluteDeviation';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_ZONE = 'validation.auctionTemplate.invalidZone';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTIONEER = 'validation.auctionTemplate.invalidAuctioneer';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_ALGORITHM = 'validation.auctionTemplate.invalidAuctionAlgorithm';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SMALLEST_UNIT = 'validation.auctionTemplate.notNullSmallestUnit';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_SMALLEST_UNIT = 'validation.auctionTemplate.invalidSmallestUnit';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SETTL_START_TYPE = 'validation.auctionTemplate.notNullSettlStartType';
export const VALIDATION_AUCTION_TEMPLATE_NOT_NULL_MAX_BID_SIZE = 'validation.auctionTemplate.notNullMaxBidSize';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_MAX_BID_SIZE = 'validation.auctionTemplate.invalidMaxBidSize';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_BIDDING_TYPE = 'validation.auctionTemplate.invalidBiddingType';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTION_ACCEPTANCE_TYPE = 'validation.auctionTemplate.invalidAuctionAcceptanceType';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_TRADE_PRICE_CALCULATION_TYPE = 'validation.auctionTemplate.invalidTradePriceCalculationType';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTION_TYPE = 'validation.auctionTemplate.invalidAuctionType';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_MAX_BID_SIZE_SMALLEST_UNIT_COMBINATION = 'validation.auctionTemplate.invalidMaxBidSizeSmallestUnitCombination';
export const VALIDATION_AUCTION_TEMPLATE_INVALID_MIN_MAX_PRICE_COMBINATION = 'validation.auctionTemplate.invalidMinMaxPriceCombination';
export const VALIDATION_AUCTION_TEMPLATE_REVENUE_SPLIT_TOO_LOW = 'validation.auctionTemplate.revenueSplitTooLow';
export const VALIDATION_AUCTION_TEMPLATE_REVENUE_SPLIT_TOO_HIGH = 'validation.auctionTemplate.revenueSplitTooHigh';

export const createAuctionTemplateErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case VALIDATION_AUCTION_TEMPLATE_EMPTY_NAME:
            result = i18n.t('auction-templates.error.auction-template-name-empty');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_NAME_LENGTH:
            result = i18n.t('auction-templates.error.auction-template-name-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_QUANTITY:
            result = i18n.t('auction-templates.error.auction-template-quantity-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_POWER:
            result = i18n.t('auction-templates.error.auction-template-power-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_DELIVERY_IN_PAST:
            result = i18n.t('auction-templates.error.auction-template-delivery-year-in-past');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_DELIVERY_YEAR:
            result = i18n.t('auction-templates.error.auction-template-delivery-year-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_PRODUCT_NOT_FOUND:
            result = i18n.t('auction-templates.error.auction-template-product-not-found');
            break;
        case VALIDATION_AUCTION_TEMPLATE_PRODUCT_NOT_ACTIVE:
            result = i18n.t('auction-templates.error.auction-template-product-not-active');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_DESCRIPTION_LENGTH:
            result = i18n.t('auction-templates.error.auction-template-description-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SHOW_LAST_PRICE:
            result = i18n.t('auction-templates.error.auction-template-show-last-price-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_EMPTY_SHOW_LAST_PRICE:
            result = i18n.t('auction-templates.error.auction-template-show-last-price-empty');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SHOW_RANKING:
            result = i18n.t('auction-templates.error.auction-template-show-ranking-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_EMPTY_SHOW_RANKING:
            result = i18n.t('auction-templates.error.auction-template-show-ranking-empty');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_LIMIT_BID_MODIFICATION:
            result = i18n.t('auction-templates.error.auction-template-limit-bid-modification-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_EMPTY_LIMIT_BID_MODIFICATION:
            result = i18n.t('auction-templates.error.auction-template-limit-bid-modification-empty');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_ZONE:
            result = i18n.t('auction-templates.error.auction-template-zone-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTIONEER:
            result = i18n.t('auction-templates.error.auction-template-auctioneer-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_ALGORITHM:
            result = i18n.t('auction-templates.error.auction-template-algorithm-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SMALLEST_UNIT:
            result = i18n.t('auction-templates.error.auction-template-smallest-unit-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_SMALLEST_UNIT:
            result = i18n.t('auction-templates.error.auction-template-smallest-unit-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_SETTL_START_TYPE:
            result = i18n.t('auction-templates.error.auction-template-settl-start-type-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_NOT_NULL_MAX_BID_SIZE:
            result = i18n.t('auction-templates.error.auction-template-max-bid-size-not-null');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_MAX_BID_SIZE:
            result = i18n.t('auction-templates.error.auction-template-max-bid-size-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_BIDDING_TYPE:
            result = i18n.t('auction-templates.error.auction-template-bidding-type-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTION_ACCEPTANCE_TYPE:
            result = i18n.t('auction-templates.error.auction-template-acceptance-type-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_TRADE_PRICE_CALCULATION_TYPE:
            result = i18n.t('auction-templates.error.auction-template-trade-price-calculation-type-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_AUCTION_TYPE:
            result = i18n.t('auction-templates.error.auction-template-auction-type-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_SPOT_REFERENCE_PRICE:
            result = i18n.t('auction-templates.error.auction-template-spot-reference-price-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_RELATIVE_DEVIATION_TOO_LOW:
            result = i18n.t('auction-templates.error.auction-template-relative-deviation-too-low', { value: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_TEMPLATE_RELATIVE_DEVIATION_TOO_HIGH:
            result = i18n.t('auction-templates.error.auction-template-relative-deviation-too-high', { value: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_ABSOLUTE_DEVIATION:
            result = i18n.t('auction-templates.error.auction-template-absolute-deviation-invalid');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_MAX_BID_SIZE_SMALLEST_UNIT_COMBINATION:
            result = i18n.t('auction-templates.error.auction-template-invalid-max-bid-size-smallest-unit-combination');
            break;
        case VALIDATION_AUCTION_TEMPLATE_INVALID_MIN_MAX_PRICE_COMBINATION:
            result = i18n.t('auction-templates.error.auction-template-invalid-min-max-price-combination');
            break;
        case VALIDATION_AUCTION_TEMPLATE_REVENUE_SPLIT_TOO_LOW:
            result = i18n.t('auction-templates.error.auction-template-revenue-split-too-low', { value: parseInt(params[0]) });
            break;
        case VALIDATION_AUCTION_TEMPLATE_REVENUE_SPLIT_TOO_HIGH:
            result = i18n.t('auction-templates.error.auction-template-revenue-split-too-high', { value: parseInt(params[0]) });
            break;
        default:
            result = undefined;
    }
    return result;
};
